<template>
	<div class="prematch-nav">
		<button
			:class="{ 'prematch-nav__item': 1, active: selectedNav === '' }"
			@click="changeNav('')"
		>
			Highlights
		</button>
		<button
			:class="{ 'prematch-nav__item': 1, active: selectedNav === 'upcoming' }"
			@click="changeNav('upcoming')"
		>
			Upcoming
		</button>
		<router-link
			v-if="selectedSport"
			:class="{
				'prematch-nav__item': 1,
				active: $route.name === 'sport-countries',
			}"
			:to="{
				name: 'sport-countries',
				params: {
					sportName: $options.filters.seoText(selectedSport.sport_name),
				},
			}"
		>
			Countries
		</router-link>
		<button
			v-if="showEsports"
			:class="{
				'prematch-nav__item': 1,
				active: selectedNav === 'quick-e',
			}"
			@click="changeNav('quick-e')"
		>
			Quick-e
		</button>
	</div>
</template>

<script>
export default {
	props: {
		selectedNav: {
			type: String,
			required: true,
			default: "",
		},
	},
	computed: {
		selectedSport() {
			return this.$store.getters.selectedSport;
		},

		showEsports() {
			return (
				this.env.esportMapping &&
				Boolean(
					this.env.esportMapping[
						this.selectedSport ? this.selectedSport.sport_id : null
					]
				)
			);
		},
	},
	methods: {
		changeNav(nav) {
			let vm = this;
			let params = {
				name: "sport",
				sportName: vm.$route.params.sportName,
			};
			if (vm.$route.name == "sport-competition") {
				params.name = "sport-competition";
				params.competitionName = vm.$route.params.competitionName;
			}
			vm.$router.push(params);
			vm.$emit("changeNav", nav);
		},
	},
};
</script>

<style lang="scss">
.prematch-nav {
	display: flex;
	flex-direction: row;
	background: var(--white);

	&__item {
		background: none;
		border: none;
		margin: 0;
		padding: 15px 10px 15px 10px;
		font-size: var(--font-normal);
		color: var(--light-black);
		font-weight: var(--font-weight-normal);
		text-decoration: none;
		&.active {
			font-weight: var(--font-weight-bold);
			color: var(--black);
		}
	}
}
</style>
